import React, { useState, useEffect } from "react";
import {
  ActionWrapper,
  ButtonsWrapper,
  BannerWrapper,
  MainWrapper,
  Banner,
  BannerInnerWrapper,
  BannerTextWrapper,
  Exclusive,
  H1,
  BannerLogo,
  HomeContentWrapper,
  ButtonText,
  HomeButton,
  IconImg,
} from "./style";
import miniLogo from "./images/mini-logo.png";
import testIcon from "./images/test-icon.svg";
import patientsIcon from "./images/patients-icon.svg";
import resourceIcon from "./images/resource-icon.svg";
import { useTranslation } from "react-i18next";
import { initTestAction } from "redux/actions/Patient";
import { connect } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import propTypes from "prop-types";
import "react-datepicker/dist/react-datepicker.css";
import { HelpPage } from "./helpPage";
import { getNotificationUtil } from "redux/utils/transverse/Notification";
import { Notification } from "components/transverse/Notification";
import localstoragekeys from "constants/localstoragekeys";
import useLocalStorage from "utils/transverse/useLocalStorage";


const Home = ({
  initTest,
  selectedLang,
  appSelected,
  getNotifications,
  notification,
}) => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const [helpPage, setHelpPage] = useState(false);
  const [t] = useTranslation("global");
  const [showNotification, setShowNotification] = useState(false);
  const [saveNotification, setSaveNotification] = useLocalStorage(localstoragekeys.notification);

  const closeNotification = () => {
    setShowNotification(false);
    setSaveNotification(true);
  }

  const onHelpPageClick = () => {
    history.push(`${path}/newpatient`);
  };

  useEffect(() => {
    getNotifications(selectedLang, appSelected);

    if (!saveNotification) {
      setShowNotification(true);
    }
  }, [getNotifications, setShowNotification, selectedLang, appSelected, saveNotification]);


  if (helpPage) {
    document.title = "About age element diagnosis system ";
    return (
      <HelpPage
        backButton={() => setHelpPage(false)}
        handleClick={onHelpPageClick}
      />
    );
  }

  document.title = "age element diagnosis system";
  return (
    <MainWrapper>
      <BannerWrapper>
        <BannerInnerWrapper>
          <Banner />
          <BannerLogo src={miniLogo} />
          <BannerTextWrapper>
            <H1>{t("home.welcome")}</H1>
            <Exclusive>{t("home.exclusive")}</Exclusive>
          </BannerTextWrapper>
        </BannerInnerWrapper>
      </BannerWrapper>
      <HomeContentWrapper>
        <ButtonsWrapper>
          <ActionWrapper onClick={() => setHelpPage(!helpPage)}>
            <IconImg src={testIcon} alt="Icon" />
            <div>
              <HomeButton primary={true}>{t("home.testAction")}</HomeButton>
              <ButtonText>{t("home.testHelpText")}</ButtonText>
            </div>
          </ActionWrapper>
          <ActionWrapper onClick={() => history.push(`${path}/patients`)}>
            <IconImg src={patientsIcon} alt="Icon" />
            <div>
              <HomeButton primary={true}>{t("home.patientsAction")}</HomeButton>
              <ButtonText>{t("home.patientsHelpText")}</ButtonText>
            </div>
          </ActionWrapper>
          <ActionWrapper onClick={() => history.push(`${path}/resources`)}>
            <IconImg src={resourceIcon} alt="Icon" />
            <div>
              <HomeButton primary={false}>
                {t("home.resourceAction")}
              </HomeButton>
              <ButtonText>{t("home.resourceHelpText")}</ButtonText>
            </div>
          </ActionWrapper>
        </ButtonsWrapper>
        {showNotification && notification.exist && (
          <Notification notification={notification} closeNotification={closeNotification} />
        )}
      </HomeContentWrapper>
    </MainWrapper>
  );
};
Home.propTypes = {
  initTest: propTypes.func,
  patient: propTypes.object,
};
const mapDispatchToProps = (dispatch) => ({
  initTest: (patient) => dispatch(initTestAction(patient)),
  getNotifications: (selectedLang, appSelected) => dispatch(getNotificationUtil(selectedLang, appSelected)),
});
const mapStateToProps = (state) => ({
  patient: state.patient.personalData,
  selectedLang: state.languages.selectedLanguage,
  appSelected: state.application,
  notification: state.notification,
});
export default connect(mapStateToProps, mapDispatchToProps)(Home);
